import { io, Socket } from 'socket.io-client';

// EVT_BROADCAST
export const EVT_RECEIVE_BROADCAST_STUDENT_CLIENT_IDX = 'broadcast:receiveStudentClientIdx';
export const EVT_RECEIVE_BROADCAST_LABEL = 'broadcast:receiveLabel';
export const EVT_RECEIVE_BROADCAST_ASSIGN_START = 'broadcast:receiveAssignStart';
export const EVT_RECEIVE_BROADCAST_ASSIGN_END = 'broadcast:receiveAssignEnd';
export const EVT_RECEIVE_BROADCAST_USER_DISCONNECTED = 'broadcast:receiveUserDisconnected';
export const EVT_RECEIVE_BROADCAST_RECEIVE_ROOM_SETTINGS = 'broadcast:receiveUpdateRoomSettings';
export const EVT_RECEIVE_BROADCAST_SHOW_SCORE = 'broadcast:showScore';
export const EVT_RECEIVE_BROADCAST_END_LESSON = 'broadcast:endLesson';

// EVT_REQUEST
export const EVT_REQUEST_USER_REQUEST_JOIN_ROOM = 'user:requestJoinRoom';
export const EVT_REQUEST_USER_ROOM_STATE = 'user:requestRoomState';
export const EVT_REQUEST_USER_ROOM_SETTINGS = 'user:requestRoomSettings';
export const EVT_REQUEST_TEACHER_ASSIGN_START = 'teacher:requestAssignStart';
export const EVT_REQUEST_TEACHER_CLIENT_LIST = 'teacher:requestClientList';
export const EVT_REQUEST_TEACHER_ASSIGN_MULTIPLE_LABEL = 'teacher:requestAssignMultipleLabel';
export const EVT_REQUEST_TEACHER_CONFIRM_ASSIGN = 'teacher:requestConfirmAssign';
export const EVT_REQUEST_TEACHER_ASSIGN_CANCEL = 'teacher:requestAssignCancel';
export const EVT_REQUEST_TEACHER_UPDATE_ROOM_SETTINGS = 'teacher:requestUpdateRoomSettings';
export const EVT_REQUEST_TEACHER_SHOW_SCORE = 'teacher:requestShowScore';
export const EVT_REQUEST_TEACHER_END_LESSON = 'teacher:requestEndLesson';

// EVT_RECEIVE
export const EVT_RECEIVE_STUDENT_TOKEN = 'student:receiveToken';

export async function CreateSocket(token?: string): Promise<Socket> {
    const socket = io(import.meta.env.VITE_IO_SERVICE_URL, {
        path: '/classroom/socket.io',
        extraHeaders: token
            ? {
                  'session-token': token,
              }
            : undefined,
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 10000,
    });

    return new Promise((resolve, reject) => {
        socket.on('connect', () => {
            resolve(socket);
        });

        socket.on('connect_error', (err) => {
            reject(err);
        });
    });
}
